import api from "./api";

const UserTrackingAPI = {
    trackVisitor: (params) => api.post(`/tracking-users/visitor`, params),
    startSession: (params) => api.post(`/tracking-users/session/start`, params),
    endSession: (params) => api.post(`/tracking-users/session/end`, params),
    pageView: (params) => api.post(`/tracking-users/pageview`, params),
};

export default UserTrackingAPI;